export default "__VITE_ASSET__4af53839__"